import axios, { AxiosResponse } from 'axios';

export const imageUrlToBase64 = async (imageUrl: string): Promise<string> => {
  try {
    const response: AxiosResponse<Blob> = await axios.get(imageUrl, {
      responseType: 'blob',
    });
    const blob = response.data;

    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.warn(error);
    throw error;
  }
};

export const convertImagesToBase64 = (images: string[]): Promise<string[]> => {
  const base64Promises = images.map(async (url) => {
    if (url.startsWith('http://')) {
      url = url.replace('http://', 'https://');
    }

    return imageUrlToBase64(url);
  });
  return Promise.all(base64Promises);
};
